import { Routes } from '@angular/router';
import { accountRoutes } from './components/account/account.routes';
import { accountRoutesGuard } from './core/guards/routes/account.guard';
import { loginRoutesGuard } from './core/guards/routes/login.guard';
export const routes: Routes = [
  {
    path: 'account',
    canActivate: [accountRoutesGuard],
    loadComponent: () =>
      import('./components/account/account.component').then(
        (x) => x.AccountComponent
      ),
    children: accountRoutes,
    // loadChildren: () =>
    //   import('./components/account/account.routes').then((x) => x.routes),
  },
  {
    path: ':lang/account',
    canActivate: [accountRoutesGuard],
    loadComponent: () =>
      import('./components/account/account.component').then(
        (x) => x.AccountComponent
      ),
    children: accountRoutes,
    // loadChildren: () =>
    //   import('./components/account/account.routes').then((x) => x.routes),
  },
  {
    path: 'login',
    canActivate: [loginRoutesGuard],
    loadComponent: () =>
      import('./components/login/login.component').then(
        (x) => x.LoginComponent
      ),
  },
  {
    path: ':lang/login',
    canActivate: [loginRoutesGuard],
    loadComponent: () =>
      import('./components/login/login.component').then(
        (x) => x.LoginComponent
      ),
  },
  // {
  //   path: 'forgot-password',
  //   loadComponent: () =>
  //     import(
  //       './components/login/forgot-password/forgot-password.component'
  //     ).then((x) => x.ForgotPasswordComponent),
  // },
  {
    path: '',
    redirectTo: 'account',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'account',
    pathMatch: 'full',
  },
];
